/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCommit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 7a5.009 5.009 0 0 1 4.9 4H22v2h-5.1a5.009 5.009 0 0 1-4.9 4 5.009 5.009 0 0 1-4.9-4H2v-2h5.1c.465-2.28 2.485-4 4.9-4zm0 2c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCommit as Commit };
